"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../../../");

var _Context = require("./Context");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var SearchSelect = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSelect, _React$Component);

  var _super = _createSuper(SearchSelect);

  function SearchSelect() {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectRef", /*#__PURE__*/_react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setCategory", function (_ref) {
      var target = _ref.target;
      var category = target.value;
      _this.props.searchResultsRef.current.scrollTop = 0;

      _this.props.setSearchCategory(category);

      if (typeof _this.props.onChangeSearchCategory === 'function') {
        _this.props.onChangeSearchCategory(category);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(SearchSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.searchCategory !== prevProps.searchCategory) {
        // update hidden select's value when category is changed by key binding
        this.selectRef.current.value = this.props.searchCategory;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$categorie = _this$props.categories,
          categories = _this$props$categorie === void 0 ? [] : _this$props$categorie,
          searchCategory = _this$props.searchCategory,
          forwardedRef = _this$props.forwardedRef;
      if (categories.length <= 1) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cloud-ui-search-select-wrapper",
        ref: forwardedRef
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "cloud-ui-search-select",
        defaultValue: searchCategory.name,
        onBlur: this.setCategory,
        onChange: this.setCategory,
        ref: this.selectRef
      }, categories.map(function (_ref2, i) {
        var name = _ref2.name,
            shortcut = _ref2.shortcut,
            props = (0, _objectWithoutProperties2["default"])(_ref2, ["name", "shortcut"]);
        return /*#__PURE__*/_react["default"].createElement("option", (0, _extends2["default"])({
          value: name
        }, props, {
          key: i
        }), name, shortcut && shortcut.name && "\xA0(".concat(shortcut.name, ")"));
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "cloud-ui-search-select-value"
      }, searchCategory), /*#__PURE__*/_react["default"].createElement(_.Icon, {
        name: "caret-down"
      }));
    }
  }]);
  return SearchSelect;
}(_react["default"].Component);

var _default = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref3) {
    var searchCategory = _ref3.searchCategory,
        setSearchCategory = _ref3.setSearchCategory,
        searchResultsRef = _ref3.searchResultsRef;
    return /*#__PURE__*/_react["default"].createElement(SearchSelect, (0, _extends2["default"])({}, props, {
      searchCategory: searchCategory,
      setSearchCategory: setSearchCategory,
      searchResultsRef: searchResultsRef,
      forwardedRef: ref
    }));
  });
});

exports["default"] = _default;